import { AlertBoxBase, cn } from "@jog/react-components"
import { ComponentProps } from "react"

export const AlertBox = ({ text, type, className }: Partial<ComponentProps<typeof AlertBoxBase>>) => (
    <AlertBoxBase type={type || "default"} className={cn("text-sm", className)} text={text} />
)
